<template>
  <div id="dizhujin">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>地主金</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">地主金</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/di-zhu-jin.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『地主金』</h5>

                <p class="project-description">
                  <span><b>如何使用地主金： </b></span>
                </p>

                <p class="project-description">
                  地主是家中最常拜的神明之一，其他的神明尚可移至屋內較隱蔽的地方，但地主卻必須當門而立，因为地主的正名是
                  “五方五土龙神，前后地主财神”
                  ，应该面向大门，向门外四方纳财，这样才可增强住宅的财运。地主并且还是住宅的守护神，当门而立，便可把牛鬼蛇神拒诸门外。
                </p>

                <p class="project-description">
                  供奉地主公就得時常為地主公焚燒地主金，普通日子随意，初一十五要燒五盒。還有上面有說到地主公是
                  “五方五土龙神，前后地主财神”
                  ，意思是指除了在家中的地主公要焚燒地主金之外，有出外拜神時也不要忘了五方五土龙神，給衪們燒一些地主金。還有在清明節時，在拜祭祖先時也別忘了后土是要用地主金來拜祭的，而且最少用上五盒，多燒不忌。
                </p>

                <p class="project-description">
                  若有小孩時常半夜啼哭，肯定是要燒地主金，而且要在半夜11時到凌辰1時之間燒，還需帶上供品：紅棗五粒、桔子五粒、糖果五粒、地主金五盒，五杯清茶、香五枝、燭一對，膜拜祈求地主公保佑小孩不要夜哭。
                </p>

                <p class="project-description">
                  還有生意不順，家不和，同樣要燒地主金，供品是：五盒地主金、黃梨一粒、桔子五粒、發糕五粒、五杯清茶、香五枝、燭一對。祈求地主公保佑。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="di-zhu-jin" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "DiZhuJin",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/DiZhuJin.vue